import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const GoogleSVG = styled(Icon).attrs({ viewBox: '0 0 28 28' })`
    width: 1.556em;
`;

function GoogleIcon(props) {
    return (
        <GoogleSVG data-test="icon-google" {...props}>
            <defs>
                <path
                    d="M19.767 8.182h-9.534v3.863h5.488c-.512 2.455-2.651 3.864-5.488 3.864-3.35 0-6.047-2.636-6.047-5.909 0-3.273 2.698-5.91 6.047-5.91A6 6 0 0 1 14 5.41l2.977-2.91C15.163.955 12.837 0 10.233 0 4.558 0 0 4.455 0 10s4.558 10 10.233 10C15.349 20 20 16.364 20 10c0-.59-.093-1.227-.233-1.818z"
                    id="googlea"
                />
                <path
                    d="M19.767 8.182h-9.534v3.863h5.488c-.512 2.455-2.651 3.864-5.488 3.864-3.35 0-6.047-2.636-6.047-5.909 0-3.273 2.698-5.91 6.047-5.91A6 6 0 0 1 14 5.41l2.977-2.91C15.163.955 12.837 0 10.233 0 4.558 0 0 4.455 0 10s4.558 10 10.233 10C15.349 20 20 16.364 20 10c0-.59-.093-1.227-.233-1.818z"
                    id="googlec"
                />
                <path
                    d="M19.767 8.182h-9.534v3.863h5.488c-.512 2.455-2.651 3.864-5.488 3.864-3.35 0-6.047-2.636-6.047-5.909 0-3.273 2.698-5.91 6.047-5.91A6 6 0 0 1 14 5.41l2.977-2.91C15.163.955 12.837 0 10.233 0 4.558 0 0 4.455 0 10s4.558 10 10.233 10C15.349 20 20 16.364 20 10c0-.59-.093-1.227-.233-1.818z"
                    id="googlee"
                />
                <path
                    d="M19.767 8.182h-9.534v3.863h5.488c-.512 2.455-2.651 3.864-5.488 3.864-3.35 0-6.047-2.636-6.047-5.909 0-3.273 2.698-5.91 6.047-5.91A6 6 0 0 1 14 5.41l2.977-2.91C15.163.955 12.837 0 10.233 0 4.558 0 0 4.455 0 10s4.558 10 10.233 10C15.349 20 20 16.364 20 10c0-.59-.093-1.227-.233-1.818z"
                    id="googleg"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h28v28H0z" fill="#FFF" />
                <g transform="translate(4 4)">
                    <mask fill="#fff" id="googleb">
                        <use xlinkHref="#googlea" />
                    </mask>
                    <path
                        d="M-.93 15.91V4.09L6.977 10z"
                        fill="#FBBC05"
                        fillRule="nonzero"
                        mask="url(#googleb)"
                    />
                </g>
                <g transform="translate(4 4)">
                    <mask fill="#fff" id="googled">
                        <use xlinkHref="#googlec" />
                    </mask>
                    <path
                        d="M-.93 4.09L6.977 10l3.256-2.773 11.162-1.772V-.91H-.93z"
                        fill="#EA4335"
                        fillRule="nonzero"
                        mask="url(#googled)"
                    />
                </g>
                <g transform="translate(4 4)">
                    <mask fill="#fff" id="googlef">
                        <use xlinkHref="#googlee" />
                    </mask>
                    <path
                        d="M-.93 15.91L13.023 5.454l3.675.454 4.697-6.818v21.818H-.93z"
                        fill="#34A853"
                        fillRule="nonzero"
                        mask="url(#googlef)"
                    />
                </g>
                <g transform="translate(4 4)">
                    <mask fill="#fff" id="googleh">
                        <use xlinkHref="#googleg" />
                    </mask>
                    <path
                        d="M21.395 20.91L6.977 10l-1.86-1.364 16.278-4.545z"
                        fill="#4285F4"
                        fillRule="nonzero"
                        mask="url(#googleh)"
                    />
                </g>
            </g>
        </GoogleSVG>
    );
}

export { GoogleIcon as default, GoogleIcon };
